import { LoadProfile } from '../../services/ProfileService';
import * as ActionTypes from '../ActionTypes';
export const LoadProfileAction = () => {
    return (dispatch) => {
        // dispatch({ type: ActionTypes.LOADING });
        console.log('Get Profile Action')
        LoadProfile().then((res) => {
            if (res.hasOwnProperty('success') && res.success === true) {
                localStorage.setItem("profile_data", JSON.stringify(res));
                // console.log(JSON.parse(localStorage.getItem("profile_data")))
                dispatch({ type: ActionTypes.LOAD_PROFILE_SUCCESS, res });
            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.LOAD_PROFILE_ERROR, res });
            }else{
                dispatch({ type: ActionTypes.LOAD_PROFILE_ERROR, res });
            }
        }).catch( (error) => {
            console.log('IF ERROR')
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}
